// API
import { useApiSWRReference } from '@/hooks/useApiSWR'

// Lodash sortBy
import sortBy from 'lodash/sortBy'

export default function useLocations() {
    const { data: locations = [] } = useApiSWRReference('/locations')

    return sortBy(locations, 'name')
}
